import { render, staticRenderFns } from "./metr-area.vue?vue&type=template&id=3e5cbc9f&scoped=true"
import script from "./metr-area.vue?vue&type=script&lang=js"
export * from "./metr-area.vue?vue&type=script&lang=js"
import style0 from "./metr-area.vue?vue&type=style&index=0&id=3e5cbc9f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5cbc9f",
  null
  
)

export default component.exports